import React, { useEffect, useState } from "react";
import "./marketplace.css";
import { withReduxData } from "../../HOC/withReduxData";
import projectSettings from "../../assets/Js/projectSettings";
import { callAPI } from "../../assets/Js/backendCommunication";

import { Spinner } from "../../Components/Spinner/Spinner";
import SearchBox from "../../Components/SearchBox/SearchBox";
import NewMarketplaceCard from "../../Components/MarketplaceGymCard/NewMarketplaceCard";
import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";

function Marketplace() {
  const [allGyms, setAllGyms] = useState([]);
  const [selectedGymList, SetSelectedGymList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getGyms();
  }, []);

  const changeHandler = (targetData) => {
    SetSelectedGymList(targetData);
  };

  const getGyms = async () => {
    let url = projectSettings.baseUrl + "/gyms/all";
    let header = true;
    let type = "GET";
    let token = null;
    let data = null;

    let response = "";

    if (response === "") {
      setIsLoading(true);
    }

    response = await callAPI(url, header, type, data, token);

    if (response) {
      setIsLoading(false);
      if (response.type === "error") {
      } else if (response.data.StatusCode === 200) {
        let _gyms = response.data.Result.map((gym) => ({
          id: gym.Id,
          name: gym.Name,
          image: gym.Image,
          tagline: gym.TagLine,
          address: gym.Address,
        }));

        setAllGyms(_gyms);
        SetSelectedGymList(_gyms);
        response = "";
      }
    }
  };

  return (
    <>
      <div className="container-fluid content-wrapper" style={{ padding: "0" }}>
        <section class="hero-section">
          <div class="hero-content">
            <h1 className="mb-3">The Athletes App</h1>
            <p>A better way to train your clients & grow your business.</p>
              <p>
                Post workouts, accept payments, chat with your team, & much
                more!
              </p>
          </div>
          <DisplayPicture showGymAvatar={true} defaultMaxHeight="300px"/>
        </section>
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="container">
              <div className="searchContainer no-gutters mb-3">
                <h2 style={{ fontWeight: "400" }}>
                  {selectedGymList.length} Gym(s) Near you
                </h2>
                <SearchBox
                  data={allGyms}
                  propertyToLookFor={"name"}
                  placeholder="Search a gym"
                  changeHandler={changeHandler}
                  searchBoxStyles="col-md-4"
                />
              </div>
            </div>
            <div className="listings container">
              {isLoading ? (
                <div>
                  <Spinner />
                </div>
              ) : selectedGymList.length ? (
                <div>
                  {selectedGymList?.map((currVal, index) => (
                    <NewMarketplaceCard
                      id={currVal.id}
                      name={currVal.name}
                      image={currVal.image}
                      tagline={currVal.tagline}
                      address={currVal.address}
                    />
                  ))}
                </div>
              ) : selectedGymList.length === 0 && !isLoading ? (
                <div className="mt-3 text-center">No Gyms Found</div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default withReduxData(Marketplace);
